enum AccountActivationResult {
  successful = 'successful',
  alreadyActivated = 'alreadyActivated',
  tokenInvalid = 'tokenInvalid',
  failed = 'failed',
}

export default AccountActivationResult;
